import { createI18n } from 'vue-i18n';
import elementEn from 'element-plus/es/locale/lang/en';
import elementJa from 'element-plus/es/locale/lang/ja';
import elementVi from 'element-plus/es/locale/lang/vi';
import en from '@/locales/en.json';
import ja from '@/locales/ja.json';
import vi from '@/locales/vi.json';

const messages = { en, ja, vi };

// デプロイ先の国ごとにビルド時にロケールが確定する (ph: en / vn: vi)。
// vite.config.tsのガードがVITE_APP_LOCALE未設定/不一致のビルドを弾くため、
// ここではフォールバックしない (旧デフォルトの'ja'は地域デプロイでは誤り)。
export const i18n = createI18n({
  legacy: false,
  locale: import.meta.env.VITE_APP_LOCALE,
  fallbackLocale: import.meta.env.VITE_APP_FALLBACK_LOCALE,
  messages,
});

// i18nロケール → Element Plusロケールのマッピング
export const setElementLocales: Record<string, typeof elementJa> = {
  en: elementEn,
  ja: elementJa,
  vi: elementVi,
};
